import { render, staticRenderFns } from "./HouseMoneyPayment.vue?vue&type=template&id=08fbd567&scoped=true&"
import script from "./HouseMoneyPayment.vue?vue&type=script&lang=js&"
export * from "./HouseMoneyPayment.vue?vue&type=script&lang=js&"
import style0 from "./HouseMoneyPayment.vue?vue&type=style&index=0&id=08fbd567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fbd567",
  null
  
)

export default component.exports